import PriceRecap from "./priceReacp";
import LinkedDepositList from "../../../deposit/LinkedDepositList";
import MarginCreator from "../../../../addOns/MarginCreator";
import { useCallback } from "react";

export default function RecapContainer({
  linkDeposit,
  handleSubmitInvoice,
  invoiceId,
  totalTtc,
  totalHt,
  discount,
  handleDiscountChange,
  handleDiscountBlur,
  totalInvoice,
  vatList,
  deleteDeposit,
  createDeposit,
  discountPrice,
  setRefresh,
  margin,
  setMargin,
  invoice,
  handleTvaClick,
  parent,
  handleCalendarIconClick,
  paymentDate,
}) {
  const onDepositLinkClick = (e, path) => {
    handleSubmitInvoice(e, path);
  };

  const updateMargin = useCallback(
    (field, value) => {
      setMargin((margin) => {
        return { ...margin, [field]: value };
      });
    },
    [setMargin]
  );
  // Helper to format date from "aaaa-mm-jj" to "jj/mm/aaaa"
  const formatDate = (dateStr) => {
    if (!dateStr) return ": non payé";
    const [year, month, day] = dateStr.split("-");
    if (!year || !month || !day) return dateStr;
    return `${day}/${month}/${year}`;
  };

  return (
    <section className="reacpContainer">
      <PriceRecap
        totalTtc={totalTtc}
        totalHt={totalHt}
        discount={discount}
        discountPrice={discountPrice || 0.0}
        handleDiscountChange={handleDiscountChange}
        handleDiscountBlur={handleDiscountBlur}
        totalInvoice={totalInvoice}
        vatList={vatList}
        onTvaClick={handleTvaClick}
      />
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        Facture payée le
        <p className="calendarLogoBg " onClick={handleCalendarIconClick}>
          <img className="calendarLogo" id="payementDate" src="/calendar-days-solid.svg" alt="" />
        </p>
        <span>
          &thinsp;
          {formatDate(paymentDate)}
        </span>
      </div>
      <LinkedDepositList
        linkDeposit={linkDeposit}
        onSubmit={onDepositLinkClick}
        deleteDeposit={deleteDeposit}
        createDeposit={createDeposit}
        parentPath={`/invoicesList/invoice/${invoiceId}`}
        setRefresh={setRefresh}
        parent={parent}
      />
      <MarginCreator
        margin={margin}
        object={invoice}
        onValidObject={handleSubmitInvoice}
        updateMargin={updateMargin}
        parent={"invoice"}
      />
    </section>
  );
}
